import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { Box, VStack } from '@cbhq/cds-web/layout';
import type { Environment } from '@cbhq/idv-sdk-web';
import IdvSDK from '@cbhq/idv-sdk-web';

const environment = (process.env.TARGET_ENV ?? 'development') as Environment;

export function TokenRoute() {
  const { token } = useParams();

  if (!token) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <VStack
        alignItems="center"
        justifyContent="center"
        height="100vh"
        padding={3}
        testID="idv-token-route"
      >
        <Box width="100%" maxWidth={600}>
          <IdvSDK token={token} environment={environment} locale="en" />
        </Box>
      </VStack>
    </Suspense>
  );
}
